import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { GatsbySeo, ProductJsonLd } from 'gatsby-plugin-next-seo';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import PageLayout from '../../containers/PageLayout';
import Seo from '../BlogPage/seo';
import Pagination from '../BlogPage/pagination';
import * as styles from './index.module.css';

import { getSrc } from 'gatsby-plugin-image';

export interface Site {
  siteMetadata: {
    title: string;
    description: string;
  };
}

export interface MarkdownRemark {
  edges: {
    node: {
      excerpt: string;
      fields: {
        slug: string;
      };
      frontmatter: {
        url: string;
        title: string;
        date: string;
        destopicscription: string;
        thumbnail: {
          childImageSharp: {
            gatsbyImageData: any;
          };
        };
      };
    };
  };
}

interface Props {
  data: {
    site: Site;
    allMarkdownRemark: MarkdownRemark[];
  };
  currentPage: number;
  numPages: number;
}

const BlogList: React.FC<Props> = ({ data, currentPage, numPages }) => {
  const siteTitle = data.site.siteMetadata.title;
  const siteDescription = data.site.siteMetadata.description;
  const posts = data.allMarkdownRemark.edges;

  return (
    <PageLayout>
      <GatsbySeo title={`blog page ${currentPage}`} description={`blogs in the blog page ${currentPage}`} titleTemplate="%s | Pagani Design Watch Official Store" />
      <Container disableGutters maxWidth="lg" sx={{ p: 2 }}>
        <div className={styles.blogPostList}>
          {posts.map(({ node }) => {
            const title = node.frontmatter.title || node.frontmatter.url;
            return (
              <article key={node.frontmatter.url} itemScope itemType="http://schema.org/Article">
                <div className={styles.image}>
                  <Link to={'/blog' + node.frontmatter.url} itemProp="url">
                    <GatsbyImage image={node.frontmatter.thumbnail.childImageSharp.gatsbyImageData} 
                    alt={title} title={title} style={{'display': 'inline'}} />
                  </Link>
                </div>
                <div className={styles.text}>
                  <header>
                    <h3>
                      <Link to={'/blog' + node.frontmatter.url} itemProp="url">
                        <span itemProp="headline">{title}</span>
                      </Link>
                    </h3>
                  </header>
                  <section>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: node.frontmatter.description || node.excerpt,
                      }}
                      itemProp="description"
                    />
                    <p className={styles.cta}>
                      <Link to={'/blog' + node.frontmatter.url} itemProp="url">
                        Read More →
                      </Link>
                    </p>
                  </section>
                </div>
              </article>
            );
          })}

          <Pagination currentPage={currentPage} numPages={numPages} path="/blog/" />
        </div>
      </Container>
    </PageLayout>
  );
};

export default BlogList;
